import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GhostButton, { type GhostButtonProps } from '@wix/da-ds/pkg/Buttons/GhostButton';
import GhostButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/GhostButtonWithContextMenu';
import { BiContextProvidedValue, BiData, SellYourArtClickBiEvent } from '@wix/da-bi/pkg/events';
import DollarHeartIcon from '@wix/da-ds/pkg/Icons/16x16/DollarHeart';
import { useBatchSellAction } from './useBatchSellAction';

interface Props {
  className?: string;
}

const BatchSellGhostButton: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { selectedDeviations, selectedIds, handleClick, submenuItems } = useBatchSellAction();

  const buttonProps = {
    variant: 'main' as GhostButtonProps['variant'],
    size: 'medium' as GhostButtonProps['size'],
    icon: DollarHeartIcon,
    biData: BiData<SellYourArtClickBiEvent>({
      evid: 353,
      deviationid: selectedIds[0],
      sectionname: BiContextProvidedValue,
      items_count: selectedDeviations.length,
      deviationid_list: selectedIds.join(','),
    }),
    fillContainerWidth: true,
  };

  return (
    <div className={className}>
      {submenuItems ? (
        <GhostButtonWithContextMenu {...buttonProps} items={submenuItems}>
          {t('studio.table.header.sell')}
        </GhostButtonWithContextMenu>
      ) : (
        <GhostButton {...buttonProps} onClick={handleClick}>
          {t('studio.table.header.sell')}
        </GhostButton>
      )}
    </div>
  );
};

BatchSellGhostButton.displayName = 'BatchSellGhostButton';

export default BatchSellGhostButton;
